
<div class="shopping-section">
    <div class="container mb-3">
        <div class="form-group d-flex mb-3" v-if="$product.colors && $product.colors.length > 0">
            <label class="mt-1 col-md-2">Color: </label> 
            <select class="form-control" v-model="color">
                <option v-for="(color, index) in $product.colors" :value="color.color" :key="index">{{color.color}}</option>
            </select>
        </div>

        <div class="form-group"
            style="gap: 0.5rem"
            v-if="$product.presentations && $product.presentations.length > 0">
            <label class="">Envases: </label> 
            <select class="form-control" v-model="actualPrice"> 
                <option v-for="(presentation, index) in $product.presentations" :value="presentation.price" :key="index">{{presentation.presentation}}</option>
            </select>
        </div>

        <div class="row purchase-info mt-5" v-if="false">
            <template>
                <label class="col-md-2 last-price">Precio: <span>${{actualPrice}}</span></label>
                <input type="number" class="col-md-5" :min="minQuantity" value="1" :max="maxQuantity" v-model="quantity" @change="validate">
                <button type="button" class="col-md-4 btn btn-primary" 
                    @click.prevent="addToCart({
                        config: {
                            price: parseInt(actualPrice), 
                            quantity: parseInt(quantity),
                            total: parseInt(total),
                            color: color
                        },
                        product: $product
                    })"> 
                    Agregar al carrito <i class="fas fa-shopping-cart"></i>
                </button>

                <label class="col-md-12"> Total: ${{total}} + IVA + Envío</label>
            </template>
        </div>
    </div>
</div>
